import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import styled from 'styled-components';
import { ReactComponent as SvgFilePdf } from '@img/icons/file-pdf.svg';
import { ReactComponent as SvgFilePlay } from '@img/icons/file-play.svg';
import { Device, from } from '@helpers/media';
import animation from '@helpers/animation';
const Container = styled.article `
  --bgColor: ${brand.grey.greyLight};
  --fgColor: ${brand.black};
  --titleColor: ${brand.sage.sageDark};

  position: relative;
  border-bottom: 1px solid ${brand.black};
    height: 100%;
`;
const Title = styled.h3 `
  ${HeadingStyles.H3Styles}
  margin: 0 0 20px;
  color: var(--titleColor);

    @media ${from(Device.Tablet)} {
        margin: 0 0 25px;
    }
`;
const Link = styled.a `
    color: var(--fgColor);
    text-decoration: none;
    display: block;
    height: 100%;

    &:focus,
    &:hover {
      outline: none;

      ${Title} {
          text-decoration: underline;
      }
    }
`;
const Inner = styled.div `
  position: relative;
  display: grid;
  height: 100%;
  width: 100%;
`;
const Tag = styled.span `
    ${fonts.matter.regular};
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 15px;

    @media ${from(Device.Tablet)} {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 25px;
    }
`;
const ContentWrapper = styled.div `
    padding: 25px 0 30px;
    display: flex;
    flex-direction: column;

    @media ${from(Device.Tablet)} {
        padding: 20px 0 35px;
    }
`;
const TitleContainer = styled.div `
    display: inline-flex;
    color: var(--titleColor);
`;
const FilePdfIcon = styled(SvgFilePdf) `
  display: block;
  height: 31px;
  width: 26px;
  margin-right: 10px;

  @media ${from(Device.TabletLarge)} {
    margin-right: 20px;
  }
`;
const FilePlayIcon = styled(SvgFilePlay) `
  display: block;
  height: 31px;
  width: 26px;
  margin-right: 20px;
`;
const Summary = styled.p `
  ${fonts.matter.regular};
  font-size: 16px;
  line-height: 22px;
  margin: 0 0 20px;
  max-width: 560px;

  @media ${from(Device.Tablet)} {
    font-size: 18px;
    line-height: 28px;
  }

  @media ${from(Device.DesktopSmall)} {
    font-size: 22px;
    line-height: 32px;
  }
`;
const CtaHolder = styled.div `
    flex: 1 0 auto;
    display: flex;
    align-items: flex-end;
`;
const Cta = styled.span `
  color: currentColor;
  ${fonts.matter.medium}
  font-size: 14px;
  line-height: 20px;
  position: relative;
  transition: color 1s ${animation.secondary};

  ${Link}:hover & {
    color: ${brand.sage.sageLight};

    &:after {
      transform: scaleX(0.5);
    }
  }

  ${Link}:focus & {
    color: ${brand.sage.sageLight};
  }  

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${brand.sage.sageDark};
    transform: scaleX(1);
    transition: transform 1s ${animation.sharp};
  }

  @media ${from(Device.Tablet)} {
    font-size: 18px;
    line-height: 26px;
  }

  @media ${from(Device.DesktopSmall)} {
    font-size: 20px;
    line-height: 28px;
  }
`;
const SearchCardStyles = {
    Container,
    ContentWrapper,
    Cta,
    CtaHolder,
    FilePdfIcon,
    FilePlayIcon,
    Inner,
    Link,
    Summary,
    Tag,
    Title,
    TitleContainer,
};
export default SearchCardStyles;
